import { useEffect, useMemo } from 'react';
import { useValidationSpecialistSubjectsSlice } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.slice';

interface UseSubjectListDataParams {
  clinicalTrialId: string | undefined;
  onSearch: (value: string) => void;
}

export const useSubjectListData = ({
  clinicalTrialId,
  onSearch,
}: UseSubjectListDataParams) => {

  const [
    state,
    actions,
    context,
    contextLoading,
    trials,
    trialsLoading,
  ] = useValidationSpecialistSubjectsSlice((s, a) => [
    s,
    a,
    s?.context,
    s?.contextLoading,
    s?.trials,
    s?.trialsLoading,
  ]);

  const sites = useMemo(() =>
    context?.sites || [],
    [context?.sites]
  );

  useEffect(() => {
    if (clinicalTrialId && actions?.fetchContext) {
      actions.fetchContext({ clinicalTrialId });
    }
    if (actions?.fetchTrials) {
      actions.fetchTrials({ role: 'VALIDATION_SPECIALIST' });
    }
  }, [clinicalTrialId]);

  useEffect(() => {
    onSearch('');
  }, [clinicalTrialId, onSearch]);

  return {
    state,
    actions,
    context,
    contextLoading,
    trials,
    trialsLoading,
    sites,
  };
};
